import * as storage from '@/common/storage';
import logger from '../../logger';
import type { WSBotMessage } from '@/types/WSBotMessage';

let jwtToken: string | undefined = undefined;

const purgeLocalstorageEntrys = (botId: string, channelId: string) => {
  try {

    logger.log('purging localstorage');
    storage.removeItems([
      `knowhere_jwt_${botId}_${channelId}`,
      'knowhere_widget_open',
    ]);
  } catch (error) {
    logger.error(error);
  }
};

const isJWTToken = (token: string) => {
  const isMoinJWTtoken =
    token.startsWith('ey') &&
    token.lastIndexOf('ey') > 0 &&
    token.includes('öey');
  return isMoinJWTtoken
}

const isTokenExpired = (timestamp: number, tokenLifetime: number) => {
  // if lifetime is not set it never Expires
  if (!tokenLifetime) return false;
  return Date.now() - timestamp > tokenLifetime;
};

export const extractJWTTokenFromMessage = (message: WSBotMessage, botId: string, channelId: string) => {
  const token = isJWTToken(message.sender) ? message.sender : message.recipient;
  console.log('extractJWTTokenFromMessage', token);
  if (token) {
    setJWTToken(token, botId, channelId);
  }
};

export const parseJWTToken = (botId: string, channelId: string, tokenLifetime: number) => {
  let token;
  try {
    token = storage.readAsObject(`knowhere_jwt_${botId}_${channelId}`);
    if (token && isTokenExpired(token.timestamp, tokenLifetime)) {
      logger.log('token expired');
      purgeLocalstorageEntrys(botId, channelId);
      return null;
    }
    // we found a token, and it's still valid
    // save it locally, and refresh the timestamp to reset the lifetime
    setJWTToken(token.token, botId, channelId);
    return token;
  } catch {
    // if we have an old - non json - token, purge it
    purgeLocalstorageEntrys(botId, channelId);

  }
};

// make sure we use this little helper respect the config if we allowed to use the locastorage
export const setJWTToken = (token: string, botId: string, channelId: string) => {
  jwtToken = token;
  storage.write(`knowhere_jwt_${botId}_${channelId}`, {
    token,
    timestamp: Date.now(),
  });
};

export const getJWTToken = () => jwtToken;
export const hasJWTToken = () => !!jwtToken;
